export default __webpack_public_path__ + "static/media/twoTrucks.e2ca85fc.png";